
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collections/[slug]",
      function () {
        return require("private-next-pages/collections/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/collections/[slug]"])
      });
    }
  